import { ArrowReply16Filled, ArrowReply24Regular, ArrowTrending24Regular, Attach16Filled, Comment16Filled, Comment24Regular, Document16Filled, Document24Regular, Edit16Filled, Edit24Regular, FolderOpen24Regular, Mention16Filled, Share16Filled, Share24Regular, TaskListSquareLtr16Filled, Video16Filled, } from '@fluentui/react-icons';
import { ActivityReason } from '@office-start/document-types';
import React from 'react';
export var getActivityIconFromReasonType = function (reasonType, isFileAccessedByMe) {
    switch (reasonType) {
        case ActivityReason.Edit:
            return isFileAccessedByMe ? React.createElement(Edit24Regular, null) : React.createElement(Edit16Filled, null);
        case ActivityReason.Comment:
            return isFileAccessedByMe ? (React.createElement(Comment24Regular, null)) : (React.createElement(Comment16Filled, null));
        case ActivityReason.CommentReply:
            return isFileAccessedByMe ? (React.createElement(ArrowReply24Regular, null)) : (React.createElement(ArrowReply16Filled, null));
        case ActivityReason.Mention:
            return React.createElement(Mention16Filled, null);
        case ActivityReason.Open:
            return React.createElement(FolderOpen24Regular, null);
        case ActivityReason.Share:
            return isFileAccessedByMe ? React.createElement(Share24Regular, null) : React.createElement(Share16Filled, null);
        case ActivityReason.Attachment:
            return React.createElement(Attach16Filled, null);
        case ActivityReason.Trending:
            return React.createElement(ArrowTrending24Regular, null);
        case ActivityReason.Video:
            return React.createElement(Video16Filled, null);
        case ActivityReason.Task:
            return React.createElement(TaskListSquareLtr16Filled, null);
        case ActivityReason.CommentReply:
            return React.createElement(ArrowReply16Filled, null);
        case ActivityReason.Default:
        default:
            return isFileAccessedByMe ? (React.createElement(Document24Regular, null)) : (React.createElement(Document16Filled, null));
    }
};
//# sourceMappingURL=getActivityIconFromReasonType.js.map